import React, { useContext, useEffect, useState } from 'react';
import { Row, Col, Form, Button, Space, Input, message } from 'antd';
import useLoading from 'hooks/use-loading';

import { useNavigate } from 'react-router-v6';
import ChatBotContext from 'hooks/chat-bot-context';

import { createWebsiteChatbot, updateWebsiteChatbot } from 'api-services/data-source';

import eventEmitter from 'utilities/event-emitter';

const AddWebsite = ({ onEditMode, sourceType, dataSource }) => {
  const { setLoading } = useLoading();
  const [form] = Form.useForm();
  const [website, setWebsite] = useState((sourceType && sourceType === 'website') ? dataSource.website_url: '');

  const navigate = useNavigate();
  const { selectedBot } = useContext(ChatBotContext);

  const onFinish = async (values) => {
    try {
      setLoading(true);
      
      const response = await (onEditMode?updateWebsiteChatbot(selectedBot, {website_url: values.website}):createWebsiteChatbot({website_url: values.website}));
      if (response.status===200){
        if(onEditMode){
          message.success('Chatbot updated successfully!');
        } else {
          message.success('Chatbot created successfully!');
          eventEmitter.emit('botSelected', { id: response.data.bot_id, bot_name: response.data.bot_name });
          navigate('/embed-on-site');
        }
      }
      else{
        message.error(onEditMode?'Chatbot updation failed!':'Chatbot creation failed!');
      }


    } catch (e) {
      setLoading(false);
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if(onEditMode && dataSource) {
      if(sourceType === 'website') {
        setWebsite(dataSource.website_url);
      }
    }
  }, [dataSource, onEditMode]);

  return (
    <Row className="addtext-wrapper">
      <Col span={24}>
        <Form id="upload-text" form={form} layout="vertical" onFinish={onFinish}>
          <Space size="middle" direction="vertical">
            <Form.Item
              name="website"
              label="Website Address"
              initialValue={website}
              rules={[
                {
                  required: true,
                  message: 'Please input website!',
                },
                {
                  type: 'url',
                  message: 'Please enter a valid URL!',
                },
              ]}
            >
              <Input placeholder={'Website'} defaultValue={website}/>
            </Form.Item>
            <div className="create-chatbot-wrapper">
              <Form.Item>
                <Button 
                  type='primary'
                  htmlType='submit'
                >
                  {onEditMode?'Update Chatbot':'Create Chatbot'}
                </Button>
              </Form.Item>
            </div>
          </Space>
        </Form>
      </Col>
    </Row>
  );
};

export default AddWebsite;
